// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__Z52FN {
  height: 100%; }
  .styles_container__Z52FN > div {
    width: 100%; }
  .styles_container__Z52FN > button {
    position: absolute;
    bottom: 1rem; }

.styles_cyclesFeed__nSNRM > div {
  width: 90%;
  padding: unset; }

.styles_drawerContainer__nolus {
  max-height: 72vh;
  overflow-y: scroll; }

button.styles_addCycleButton__\\+fZuT {
  height: 100%;
  width: 100%;
  display: flex;
  border: 1px dashed grey;
  justify-content: center;
  align-items: center;
  margin: 1rem 0rem;
  padding: 1.5rem; }

.styles_actionsContainer__Yq8nY {
  width: 100%;
  border-top: 1px solid #8080801a; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/BoothActiveCycletab/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AACA;EACI,YAAY,EAAA;EADhB;IAGQ,WAAW,EAAA;EAHnB;IAMQ,kBAAkB;IAClB,YAAY,EAAA;;AAKpB;EAEQ,UAAU;EACV,cAAc,EAAA;;AAItB;EACI,gBAAgB;EAChB,kBAAkB,EAAA;;AAItB;EACI,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe,EAAA;;AAGnB;EACI,WAAW;EACX,+BC3Bc,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n.container { \n    height: 100%;\n    & > div {\n        width: 100%;\n    }\n    & > button {\n        position: absolute;\n        bottom: 1rem;\n    }\n}\n\n\n.cyclesFeed {\n    & > div {\n        width: 90%;\n        padding: unset;\n    }\n}\n\n.drawerContainer {\n    max-height: 72vh;\n    overflow-y: scroll;\n}\n\n\nbutton.addCycleButton {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    border: 1px dashed grey;\n    justify-content: center;\n    align-items: center;\n    margin: 1rem 0rem;\n    padding: 1.5rem;\n}\n\n.actionsContainer {\n    width: 100%;\n    border-top: 1px solid $grey10;\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__Z52FN`,
	"cyclesFeed": `styles_cyclesFeed__nSNRM`,
	"drawerContainer": `styles_drawerContainer__nolus`,
	"addCycleButton": `styles_addCycleButton__+fZuT`,
	"actionsContainer": `styles_actionsContainer__Yq8nY`
};
export default ___CSS_LOADER_EXPORT___;
